import React from "react";
import { ArrowLeft } from "lucide-react";

// variant="default" — белый squircle на сером фоне
// variant="glass"   — полупрозрачный на изображении
const BackButton = ({ onClick, disabled, variant = "default" }) => {
    const base = "w-10 h-10 flex items-center justify-center rounded-2xl active:scale-95 transition-all duration-150 select-none shrink-0";

    const styles = {
        default: "bg-white border border-gray-200 text-gray-600 shadow-sm hover:bg-gray-50",
        glass:   "bg-black/25 backdrop-blur-md text-white",
    };

    return (
        <button onClick={onClick} disabled={disabled} className={`${base} ${styles[variant]}`}>
            <ArrowLeft size={18} strokeWidth={2.5} />
        </button>
    );
};

export default BackButton;
